const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/home.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/home")({
  beforeLoad: () => {
    redirect({
      to: "/feed",
      replace: true,
      search: true,
      throw: true
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});